// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1XdYB","dragIcon":"SortableItem_dragIcon__bNTtd","disabled":"SortableItem_disabled__2UuQu"};